import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';

interface RevokeConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  error: string | null;
  title: string;
  description: string;
  itemLabel: string;
}

export const RevokeConfirmDialog: React.FC<RevokeConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
  error,
  title,
  description,
  itemLabel,
}) => {
  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {description}
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          {itemLabel}
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} /> : undefined}
        >
          {isSubmitting ? 'Revoking...' : 'Revoke'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
